import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ProgressBarStatus } from '../../models/ProgressBarStatus';

@Component({
    selector: 'sera-progress-bar',
    templateUrl: './sera-progress-bar.component.html',
    styleUrls: ['./sera-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraProgressBarComponent implements OnInit, OnDestroy {
    @Input()
    mode = 'determinate';

    @Input()
    showValue = false;

    @Input()
    progressStatus: ProgressBarStatus | undefined;

    @Input()
    styleClass: string = 'sera-progress-bar__container';

    @Input()
    style = '';

    @Input()
    styleBar = 'sera-progress-bar__bar';

    statusText = '.';
    intervalId: any;
    maxDots = 3;
    currentDots = 1;

    constructor(private readonly zone: NgZone, private readonly changeDetectorRef: ChangeDetectorRef) {}

    ngOnInit() {
        this.setUpProgressLoadingBehaviour();
    }

    setUpProgressLoadingBehaviour() {
        this.intervalId = setInterval(() => {
            this.zone.run(() => {
                this.updateStatusText();
                this.changeDetectorRef.detectChanges();
            });
        }, 1000);
    }

    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    updateStatusText() {
        this.currentDots = (this.currentDots % this.maxDots) + 1;
        this.statusText = '.'.repeat(this.currentDots);
    }
}
